// extracted by mini-css-extract-plugin
export default {"emptyText":"GenericListView__emptyText___dbxOA","container":"GenericListView__container___KcSAY"};